import {defineMessages} from "react-intl"

export const actionMessages = defineMessages({
    shortcutActionPlaceholder: {
        id: "shortcutAction.set_setting_modal.default_action",
        defaultMessage: "Select an action",
    },
    shortcutActionError: {
        id: "shortcutAction.set_setting_modal.selection_error",
        defaultMessage: "Please choose a valid action",
    },
    shortcutActionHeader: {
        id: "shortcutAction.set_setting_modal.action_label",
        defaultMessage: "Action",
    },
    shortcutActionColorLabel: {
        id: "shortcutAction.set_setting_modal.action_color_label",
        defaultMessage: "Color",
    },
    shortcutActionLabel: {
        id: "shortcutAction.set_settings_modal.label",
        defaultMessage: "Label",
    },
    shortcutActionInputError: {
        id: "shortcutAction.set_setting_modal.input_error",
        defaultMessage: "Please fill out the field",
    },

    shortcutActionInvoicesListLabel: {
        id: "shortcutAction.set_setting_modal.invoices_list_label",
        defaultMessage: "Invoice to duplicate"
    },
    shortcutActionQuotesListLabel: {
        id: "shortcutAction.set_setting_modal.quotes_list_label",
        defaultMessage: "Quote to duplicate"
    },

    "create-contact": {
        id: "shortcutAction.actions.create-contact",
        defaultMessage: "New Contact",
    },
    "create-quote": {
        id: "shortcutAction.actions.create-quote",
        defaultMessage: "New Quote",
    },
    "create-invoice": {
        id: "shortcutAction.actions.create-invoice",
        defaultMessage: "New Invoice",
    },
    "create-order": {
        id: "shortcutAction.actions.create-order",
        defaultMessage: "New Order",
    },
    "create-subscription": {
        id: "shortcutAction.actions.create-subscription",
        defaultMessage: "New Subscription",
    },
    "create-appointment": {
        id: "shortcutAction.actions.create-appointment",
        defaultMessage: "New Appointment",
    },

    "clone-invoice": {
        id: "shortcutAction.actions.clone-invoice",
        defaultMessage: "Clone Invoice",
    },

    "clone-quote": {
        id: "shortcutAction.actions.clone-quote",
        defaultMessage: "Clone Quote",
    },
})

export const filterMessages = defineMessages({
    shortcutFilterDefaultSavedFilter: {
        id: "shortcutFilter.set_setting_modal.default_saved_filter",
        defaultMessage: "Select a saved filter",
    },
    shortcutFilterInputError: {
        id: "shortcutFilter.set_setting_modal.input_error",
        defaultMessage: "Please write a title",
    },
    shortcutFilterSavedFilterError: {
        id: "shortcutFilter.set_setting_modal.selection_error",
        defaultMessage: "Please choose a valid filter",
    },
    shortcutFilterLabel: {
        id: "shortcutFilter.set_setting_modal.label",
        defaultMessage: "Label",
    }, 
    shortcutFilterSavedFilterLabel: {
        id: "shortcutFilter.set_setting_modal.saved_filter_label",
        defaultMessage: "Saved Filter",
    },
    shortcutFilterColorLabel: {
        id: "shortcutFilter.set_setting_modal.filter_color_label",
        defaultMessage: "Color",
    },
})

export const colorListMessages = defineMessages({
    "primary": {
        id: "shortcutFilter.set_setting_modal.color_value_blue",
        defaultMessage: "Blue",
    },
    "secondary": {
        id: "shortcutFilter.set_setting_modal.color_value_gray",
        defaultMessage: "Gray",
    },
    "success": {
        id: "shortcutFilter.set_setting_modal.color_value_green",
        defaultMessage: "Green",
    },
    "danger": {
        id: "shortcutFilter.set_setting_modal.color_value_red",
        defaultMessage: "Red",
    }, 
    "warning": {
        id: "shortcutFilter.set_setting_modal.color_value_yellow",
        defaultMessage: "Yellow",
    },
    "info": {
        id: "shortcutFilter.set_setting_modal.color_value_teal",
        defaultMessage: "Teal",
    },
    "custom-secondary": {
        id: "shortcutFilter.set_setting_modal.color_value_purple",
        defaultMessage: "Purple",
    }
})


// WEBPACK FOOTER //
// ./src/shortcuts/messages/messages.ts